import Vue from 'vue';
import http from '../utils/http';

export default {
    state: {
        finances: null,
        intermediary: null,
        finances_all: [],
        intermediary_all: [],
    },
    mutations: {
        loadFinances(state, payload) {
			state.finances_all = payload;
		},
        loadIntermediary(state, payload) {
			state.intermediary_all = payload;
		},
        loadTeamFinances(state, payload) {
			state.finances = payload;
		},
        loadTeamIntermediary(state, payload) {
			state.intermediary = payload;
		},
        addFinances(state, payload) {
            let index = state.finances?.length
            if (!index) {
                state.finances = payload;
            } else {
                Vue.set(state.finances, index, payload)
            }  	   
        },
        addIntermediary(state, payload) {
            let index = state.intermediary?.length
            if (!index) {
                state.intermediary = payload;
            } else {
                Vue.set(state.intermediary, index, payload) 
            }  
        },
        deleteFinances(state, payload) {
            state.finances =  state.finances?.filter(item => item.id !== payload)
        },
        deleteIntermediary(state, payload) {
            state.intermediary =  state.intermediary?.filter(item => item.id !== payload)
        }
    },
    actions: {
        //fetch all finances by game id & round
        async fetchFinances({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/finances/game/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const finances = await result.data 
                   commit('loadFinances', finances)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async fetchIntermediary({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/intermediary/game/${payload.gameId}?round=${payload.round}`);
                /* console.log(result) */
                if (result) {
                   const intermediary = await result.data 
                   commit('loadIntermediary', intermediary)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //fetch team finances by game id & round
        async fetchTeamFinances({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/finances/team/${payload.teamId}?gameId=${payload.gameId}&round=${payload.round}`);
                if (result) {
                   const finances = await result.data 
                   commit('loadTeamFinances', finances)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async fetchTeamIntermediary({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/intermediary/team/${payload.teamId}?gameId=${payload.gameId}&round=${payload.round}`);
                if (result) {
                   const intermediary = await result.data 
                   commit('loadTeamIntermediary', intermediary)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addFinances({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            const team = payload.team;
            delete payload.team;
            payload.teamId = team.id;

            try {
                const result = await http.post(`/finances`, payload);
                
                if (result) {
                   const finances = await result.data; 
                   finances.team = team;
                   commit('addFinances', finances);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addIntermediary({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.post(`/intermediary`, payload);
                
                if (result) {
                   const intermediary = await result.data; 
                   commit('addIntermediary', intermediary);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async updateIntermediary({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.put(`/intermediary/${payload.id}`, payload);
                
                if (result) {
                   const intermediary = await result.data; 
                   commit('loadIntermediary', intermediary);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteFinances({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/finances/${payload}`);
                commit('deleteFinances', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteIntermediary({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/intermediary/${payload}`);
                commit('deleteIntermediary', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateFinances({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/finances/calculate/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const finances = await result.data 
                   commit('loadFinances', finances)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async calculateIntermediary({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/intermediary/calculate/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const intermediary = await result.data 
                   commit('loadIntermediary', intermediary)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async financesTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            console.log(payload)
            try {
                await http.get(`/finances/transition/${payload.gameId}?round=${payload.round}`);             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async intermediaryTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                await http.get(`/intermediary/transition/${payload.gameId}?round=${payload.round}`);             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
    },
    getters: {
        finances (state) {
            return state.finances;
        },
        finances_all (state) {
            return state.finances_all;
        },
        intermediary(state) {
            return state.intermediary;
        },
        intermediary_all(state) {
            return state.intermediary_all;
        },
    }
}